import { FormField, Textarea } from '@amzn/awsui-components-react';

export const TextAreaField = (props: { label: string, value: string, onChange: ({ detail }: any) => void }) => {
  return (
    <FormField label={props.label}>
      <Textarea onChange={props.onChange} value={props.value} disableBrowserAutocorrect/>
    </FormField>
  )
}